import $ from 'jquery';

class CategoryAndTagHeader {
    constructor(element) {
        this._div = element;
        this._categoriesButton = "";
        this._categoriesElement = "";

        this.getData();
        this.bindEvents();
    }
    getData() {
        this._categoriesButton = $(this._div).find('[data-thematic-title]');
        this._categoriesElement = $(this._div).find('[data-thematic-links]');
    }
    bindEvents() {
        var _this = this;
        $(this._categoriesButton).on('click', function (event) {
            event.preventDefault();
            _this.showHide();
        });
    }
    showHide() {
        if (window.innerWidth < 768) {
            if (this._categoriesElement.is(':hidden')) {
                this._categoriesElement.slideDown();
                this._categoriesButton.addClass("active");
            } else {
                this._categoriesElement.slideUp();
                this._categoriesButton.removeClass("active");
            }
        }
    }
}

export default CategoryAndTagHeader;
